<template>
	<div class="product-tile ragnarok">
		<div class="product custom is-flex-bottom" @mouseover="showDescription()" @mouseleave="hideDescription()">
			<slide-y-up-transition>
				<div class="quick-info flex-middle-center" v-show="viewingDescription">
					<slot v-if="$slots.quickInfo" name="quickInfo"></slot>
					<template v-else>
						<div class="content">
							<div class="headline">{{ headline }}</div>
							<p>{{ description }}</p>
						</div>
					</template>
				</div>
			</slide-y-up-transition>
			<div class="description" :class="{ overlaid: viewingDescription }">
				<slot v-if="$slots.description" name="description"></slot>
				<template v-else>
					<div class="headline">{{ headline }}</div>
					<p class="content">{{ description }}</p>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
    import {SlideYUpTransition} from "vue2-transitions";

    export default {
        name: "CustomProductTile",

        components: {
            SlideYUpTransition
        },

        props: {
			headline: {default: null, type: String},
			description: {default: null, type: String},
        },

        data: function () {
            return {
                viewingDescription: false
            }
        },

        methods: {
            showDescription() {
                this.viewingDescription = true;
            },

            hideDescription() {
                this.viewingDescription = false;
            },
        }

    }
</script>
